<div class="modal-header">
  <button type="button" class="btn-close" (click)="bsModalRef.hide()" [attr.aria-label]="'button.close' | translate"></button>
</div>
<div class="modal-body">
  <p>
    {{ 'hint.invite-email.' + tenant | translate }}
  </p>

  <app-form-field-text
    [field]="emailControl"
   
    label="label.email"
  ></app-form-field-text>
  <p class="hint-privacy-policy">
    <span>
      {{
        'hint.privacy-policy-part-1.' + tenant | translate
      }}
    </span>

    <a
      class="link"
      (click)="openDialog('privacy-terms')"
      attr.aria-label="{{
        'hint.privacy-policy-part-2-link' | translate
      }}"
      >{{
        'hint.privacy-policy-part-2-link' | translate
      }}</a
    >{{ 'hint.privacy-policy-part-3' | translate }}
  </p>
</div>
<div class="modal-footer">
  <button
    class="btn btn-primary"
    (click)="submit()"
  >
    {{ 'button.get-invite' | translate }}
  </button>
</div>
